/**
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';

export const ActionCreators = {
  // get network options
  RequestNetworkOptions: new ActionCreator<'RequestNetworkOptions', any>('RequestNetworkOptions'),
  ReceivedNetworkOptionsSuccess: new ActionCreator<'ReceivedNetworkOptionsSuccess', any>(
    'ReceivedNetworkOptionsSuccess',
  ),
  ReceivedNetworkOptionsError: new ActionCreator<'ReceivedNetworkOptionsError', any>('ReceivedNetworkOptionsError'),
  ClearReceivedNetworkOptionsError: new ActionCreator<'ClearReceivedNetworkOptionsError', any>(
    'ClearReceivedNetworkOptionsError',
  ),

  // get terminalType options
  RequestTerminalTypeOptions: new ActionCreator<'RequestTerminalTypeOptions', any>('RequestTerminalTypeOptions'),
  ReceivedTerminalTypeOptionsSuccess: new ActionCreator<'ReceivedTerminalTypeOptionsSuccess', any>(
    'ReceivedTerminalTypeOptionsSuccess',
  ),
  ReceivedTerminalTypeOptionsError: new ActionCreator<'ReceivedTerminalTypeOptionsError', any>(
    'ReceivedTerminalTypeOptionsError',
  ),
  ClearReceivedTerminalTypeOptionsError: new ActionCreator<'ClearReceivedTerminalTypeOptionsError', any>(
    'ClearReceivedTerminalTypeOptionsError',
  ),

  // get platformType options
  RequestPlatformTypeOptions: new ActionCreator<'RequestPlatformTypeOptions', any>('RequestPlatformTypeOptions'),
  ReceivedPlatformTypeOptionsSuccess: new ActionCreator<'ReceivedPlatformTypeOptionsSuccess', any>(
    'ReceivedPlatformTypeOptionsSuccess',
  ),
  ReceivedPlatformTypeOptionsError: new ActionCreator<'ReceivedPlatformTypeOptionsError', any>(
    'ReceivedPlatformTypeOptionsError',
  ),
  ClearReceivedPlatformTypeOptionsError: new ActionCreator<'ClearReceivedPlatformTypeOptionsError', any>(
    'ClearReceivedPlatformTypeOptionsError',
  ),

  // get datapathLabel options
  RequestDatapathLabelOptions: new ActionCreator<'RequestDatapathLabelOptions', any>('RequestDatapathLabelOptions'),
  ReceivedDatapathLabelOptionsSuccess: new ActionCreator<'ReceivedDatapathLabelOptionsSuccess', any>(
    'ReceivedDatapathLabelOptionsSuccess',
  ),
  ReceivedDatapathLabelOptionsError: new ActionCreator<'ReceivedDatapathLabelOptionsError', any>(
    'ReceivedDatapathLabelOptionsError',
  ),
  ClearReceivedDatapathLabelOptionsError: new ActionCreator<'ClearReceivedDatapathLabelOptionsError', any>(
    'ClearReceivedDatapathLabelOptionsError',
  ),

  // get customerGroup options
  RequestCustomerGroupOptions: new ActionCreator<'RequestCustomerGroupOptions', any>('RequestCustomerGroupOptions'),
  ReceivedCustomerGroupOptionsSuccess: new ActionCreator<'ReceivedCustomerGroupOptionsSuccess', any>(
    'ReceivedCustomerGroupOptionsSuccess',
  ),
  ReceivedCustomerGroupOptionsError: new ActionCreator<'ReceivedCustomerGroupOptionsError', any>(
    'ReceivedCustomerGroupOptionsError',
  ),
  ClearReceivedCustomerGroupOptionsError: new ActionCreator<'ClearReceivedCustomerGroupOptionsError', any>(
    'ClearReceivedCustomerGroupOptionsError',
  ),

  // get Antenna options
  RequestAntennaOptions: new ActionCreator<'RequestAntennaOptions', any>('RequestAntennaOptions'),
  ReceivedAntennaOptionsSuccess: new ActionCreator<'ReceivedAntennaOptionsSuccess', any>(
    'ReceivedAntennaOptionsSuccess',
  ),
  ReceivedAntennaOptionsError: new ActionCreator<'ReceivedAntennaOptionsError', any>('ReceivedAntennaOptionsError'),
  ClearReceivedAntennaOptionsError: new ActionCreator<'ClearReceivedAntennaOptionsError', any>(
    'ClearReceivedAntennaOptionsError',
  ),

  // get modemType options
  RequestModemTypeOptions: new ActionCreator<'RequestModemTypeOptions', any>('RequestModemTypeOptions'),
  ReceivedModemTypeOptionsSuccess: new ActionCreator<'ReceivedModemTypeOptionsSuccess', any>(
    'ReceivedModemTypeOptionsSuccess',
  ),
  ReceivedModemTypeOptionsError: new ActionCreator<'ReceivedModemTypeOptionsError', any>(
    'ReceivedModemTypeOptionsError',
  ),
  ClearReceivedModemTypeOptionsError: new ActionCreator<'ClearReceivedModemTypeOptionsError', any>(
    'ClearReceivedModemTypeOptionsError',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

// network options
export function requestNetworkOptions() {
  return ActionCreators.RequestNetworkOptions.create();
}

export function clearReceivedNetworkOptionsError() {
  return ActionCreators.ClearReceivedNetworkOptionsError.create();
}

// terminal type options
export function requestTerminalTypeOptions() {
  return ActionCreators.RequestTerminalTypeOptions.create();
}

export function clearReceivedTerminalTypeOptionsError() {
  return ActionCreators.ClearReceivedTerminalTypeOptionsError.create();
}

// platform type options
export function requestPlatformTypeOptions() {
  return ActionCreators.RequestPlatformTypeOptions.create();
}

export function clearReceivedPlatformTypeOptionsError() {
  return ActionCreators.ClearReceivedPlatformTypeOptionsError.create();
}

// datapath label options
export function requestDatapathLabelOptions() {
  return ActionCreators.RequestDatapathLabelOptions.create();
}

export function clearReceivedDatapathLabelOptionsError() {
  return ActionCreators.ClearReceivedDatapathLabelOptionsError.create();
}

// customer group options
export function requestCustomerGroupOptions() {
  return ActionCreators.RequestCustomerGroupOptions.create();
}

export function clearReceivedCustomerGroupOptionsError() {
  return ActionCreators.ClearReceivedCustomerGroupOptionsError.create();
}

// antenna options
export function requestAntennaOptions() {
  return ActionCreators.RequestAntennaOptions.create();
}

export function clearReceivedAntennaOptionsError() {
  return ActionCreators.ClearReceivedAntennaOptionsError.create();
}

// modem type options
export function requestModemTypeOptions() {
  return ActionCreators.RequestModemTypeOptions.create();
}

export function clearReceivedModemTypeOptionsError() {
  return ActionCreators.ClearReceivedModemTypeOptionsError.create();
}